import React from 'react'
import { ContainerProps } from './Container.types'
import cn from 'classnames'
import styles from './Container.module.scss'

const Container = (
  {
    children,
    className,
    centered,
    maxWidth
  }: React.PropsWithChildren<ContainerProps>) => {
  return (
    <div className={cn(styles.container, centered && styles.centered, className)} style={{maxWidth: maxWidth}}>
      {children}
    </div>
  )
}

export default Container